import { render } from "./main.vue?vue&type=template&id=f53f1c12"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import exportComponent from "/Users/willson/Desktop/project/welove/admin_js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__